import { render, staticRenderFns } from "./InvestmentConfig.vue?vue&type=template&id=5e910d60&scoped=true"
import script from "./InvestmentConfig.vue?vue&type=script&lang=js"
export * from "./InvestmentConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e910d60",
  null
  
)

export default component.exports